module.exports = __webpack_public_path__ + "img/VinteageGearBox.2ce71c59.jpeg";